export default function SolutionsHero() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden pt-20">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20technology%20education%20background%20with%20interconnected%20nodes%20and%20digital%20learning%20elements%2C%20modern%20STEM%20concept%20with%20geometric%20patterns%20in%20teal%20and%20blue%20gradient%2C%20professional%20minimalist%20design%20with%20depth%20and%20lighting&width=1920&height=1080&seq=solutions-hero-001&orientation=landscape"
          alt="Solutions Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-24 text-center">

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
          Comprehensive STEM Solutions<br />
          <span className="text-teal-400">For Every School</span>
        </h1>
        <p className="text-base md:text-lg text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed">
          From complete lab infrastructure to teacher training and student career guidance—everything you need for successful STEM integration
        </p>

        {/* Quick Links */}
        <div className="flex flex-wrap items-center justify-center gap-3">
          {[
            { name: 'STEM Lab', href: '#stem-lab', icon: 'ri-flask-line' },
            { name: 'AI & Robotics', href: '#ai-robotics', icon: 'ri-robot-2-line' },
            { name: 'Workshops', href: '#workshops', icon: 'ri-lightbulb-line' }
          ].map((link, idx) => (
            <a
              key={idx}
              href={link.href}
              className="px-5 py-2.5 bg-white/10 backdrop-blur-md border border-white/20 text-white text-sm font-semibold rounded-lg hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className={`${link.icon} text-base`}></i>
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
